module.exports = __webpack_public_path__ + "static/media/unit 5-8.0f88952c.jpg";